<template>
  <div class="vx-row" id="printing_freight">
    <div class="vx-col lg:w-3/5 w-full" style="padding-right: 5px">
      <vx-card
        title="Freight Receipt Generate"
        subtitle="Be sure your generating the receipts of your branch and they were delivered or ready to deliver"
      >
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full mb-2" v-if="!genrationFreight">
            <vs-input
              class="w-full"
              ref="lrgenerateText"
              label-placeholder="LR NO"
              v-model="currentLrNo"
              v-on:keyup.enter="getLrDetails"
              :disabled="loadingLrData"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2" v-if="genrationFreight">
            <v-select
              class="mt-5"
              label="collectionAgentName"
              :options="collectionAgents"
              @option:selected="agentSelected"
              v-model="selectedCollectionAgent"
            />
          </div>
          <vx-tooltip
            text="Add Collection Agent"
            position="top"
            v-if="genrationFreight"
          >
            <vs-button
              @click="showAddEditDialog = true"
              class="mr-3 mb-2 mt-5"
              radius
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-plus"
            ></vs-button>
          </vx-tooltip>
          <div class="vx-col sm:w-1/3 w-full mb-2" v-if="!genrationFreight">
            <vs-button
              class="mr-3 mb-2 mt-5"
              @click="generateFreight"
              :disabled="!freightUpdatingLrs.length > 0"
              >Generate</vs-button
            >
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2" v-if="genrationFreight">
            <vs-button
              class="mr-3 mb-2 mt-5"
              @click="printFreight"
              :disabled="!collectionAgent > 0"
              >Print</vs-button
            >
          </div>
        </div>
      </vx-card>
      <!-- <div class="vx-row" v-if="genrationFreight">
        <td class="font-semibold">Session Id</td>
        <td>{{ sessionId }}</td>
      </div> -->
      <!-- subtitle="By Entering those details here y sure your generating the receipts of your branch and they were delivered" -->
      <vs-popup
        class="holamundo digitelex-popup"
        :title="modalTitle"
        :active.sync="showAddEditDialog"
      >
        <addEditCollectionAgent
          :frmData="formData"
          v-if="showAddEditDialog"
          @submitResponse="reloadData"
        ></addEditCollectionAgent>
      </vs-popup>
      <vx-card
        v-if="freightUpdatingLrs.length > 0 && !genrationFreight"
        :title="'Freight Receipt List (' + freightUpdatingLrs.length + ')'"
        class="mt-1 freightlrList"
        style="height: 26.5rem"
      >
        <VuePerfectScrollbar
          class="scroll-area--customizer pt-1 pb-1"
          :settings="settings"
          style="height: 26.5rem"
        >
          <!-- pagination
            max-items="6"
            search -->
          <vs-table stripe :data="freightUpdatingLrs">
            <template slot="thead">
              <vs-th sort-key="consignmentLrNo">LR.No</vs-th>
              <vs-th sort-key="consignmentPackagesTotalCnt"
                >No.of Articles</vs-th
              >
              <vs-th>Freight Charge</vs-th>
              <vs-th>Hamali Charge</vs-th>
              <vs-th>Stationary Charge</vs-th>
              <vs-th>Collection Charge</vs-th>
              <vs-th>DD Charge</vs-th>
              <vs-th>Other Charge</vs-th>
              <vs-th>LR Charge </vs-th>
              <vs-th>UnLoading Charge</vs-th>
              <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.consignmentLrNo">{{
                  tr.consignmentLrNo
                }}</vs-td>
                <vs-td :data="tr.consignmentPackagesTotalCnt">{{
                  tr.consignmentPackagesTotalCnt
                }}</vs-td>
                <vs-td :data="tr.consignmentFreightCharge">
                  <template>
                    <vs-input
                      @focus="currentFreight(tr, indextr)"
                      v-model="tr.consignmentFreightCharge"
                      style="width: 5rem"
                    />
                  </template>
                </vs-td>
                <vs-td :data="tr.consignmentHamaliCharge">
                  <template>
                    <vs-input
                      @focus="currentFreight(tr, indextr)"
                      v-model="tr.consignmentHamaliCharge"
                      style="width: 3.5rem"
                    />
                  </template>
                </vs-td>
                <vs-td :data="tr.consignmentStationaryCharge">
                  <template>
                    <vs-input
                      @focus="currentFreight(tr, indextr)"
                      v-model="tr.consignmentStationaryCharge"
                      style="width: 3.5rem"
                    />
                  </template>
                </vs-td>
                <vs-td :data="tr.consignmentCollectionCharges">
                  <template>
                    <vs-input
                      @focus="currentFreight(tr, indextr)"
                      v-model="tr.consignmentCollectionCharges"
                      style="width: 3.5rem"
                    />
                  </template>
                </vs-td>
                <vs-td :data="tr.consignmentDoorDeliveryCharge">
                  <template>
                    <vs-input
                      @focus="currentFreight(tr, indextr)"
                      v-model="tr.consignmentDoorDeliveryCharge"
                      style="width: 3.5rem"
                    />
                  </template>
                </vs-td>
                <vs-td :data="tr.consignmentOtherCharge">
                  <template>
                    <vs-input
                      @focus="currentFreight(tr, indextr)"
                      v-model="tr.consignmentOtherCharge"
                      style="width: 3.5rem"
                    />
                  </template>
                </vs-td>
                <vs-td :data="tr.consignmentLrCopyCharge">
                  <template>
                    <vs-input
                      @focus="currentFreight(tr, indextr)"
                      v-model="tr.consignmentLrCopyCharge"
                      style="width: 3.5rem"
                    />
                  </template>
                </vs-td>
                <vs-td :data="tr.consignmentUnloadingCharge">
                  <template>
                    <vs-input
                      @focus="currentFreight(tr, indextr)"
                      v-model="tr.consignmentUnloadingCharge"
                      style="width: 3.5rem"
                    />
                  </template>
                </vs-td>
                <vs-td>
                  <!-- @click="removeConsignment(data[indextr], indextr)" -->
                  <vs-button
                    :data="data[indextr]"
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-trash"
                    color="danger"
                    @click="removeConsignment(data[indextr], indextr)"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </VuePerfectScrollbar>
      </vx-card>
    </div>
    <div
      class="vx-col lg:w-2/5 w-full"
      id="div-with-loading"
      style="padding-left: 5px"
      v-if="!genrationFreight"
    >
      <vx-card
        v-if="currentLrDetails.consignmentLrNo"
        :title="lrDeatilsHeader"
        class="freightlrDetails"
      >
        <VuePerfectScrollbar
          class="scroll-area--customizer pt-2 pb-1"
          :settings="settings"
        >
          <div v-if="currentLrDetails.consignmentLrNo">
            <div class="vx-row" style="margin: 0px">
              <div class="vx-col lg:w-1/1 w-full mb-2" style="padding: 0 5px">
                <vx-card>
                  <div class="vx-row" style="margin: 0px">
                    <div
                      class="vx-col lg:w-1/3 w-full mb-2"
                      style="padding: 0 5px"
                    >
                      <table>
                        <tr>
                          <td class="font-semibold">From :</td>
                          <td>
                            {{ currentLrDetails.consignmentFromBranchName }}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div
                      class="vx-col lg:w-1/3 w-full mb-2"
                      style="padding: 0 5px"
                    >
                      <table>
                        <tr>
                          <td class="font-semibold">To :</td>
                          <td>
                            {{ currentLrDetails.consignmentToBranchName }}
                          </td>
                        </tr>
                      </table>
                    </div>

                    <div
                      class="vx-col lg:w-1/3 w-full mb-2"
                      style="padding: 0 5px"
                    >
                      <table>
                        <tr>
                          <td class="font-semibold">Date :</td>
                          <td>
                            {{
                              currentLrDetails.consignmentBookedDate
                                | date(true)
                            }}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div class="vx-row" style="margin: 0px">
                    <div
                      class="vx-col lg:w-1/3 w-full mb-2"
                      style="padding: 0 5px"
                    >
                      <table>
                        <tr>
                          <td class="font-semibold">EwayBill :</td>
                          <td>
                            {{ currentLrDetails.consignmentEwayBillNo }}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div
                      class="vx-col lg:w-1/3 w-full mb-2"
                      style="padding: 0 5px"
                    >
                      <table>
                        <tr>
                          <td class="font-semibold">#Invoice :</td>
                          <td>
                            {{ currentLrDetails.consignmentProductInvoiceNo }}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div
                      class="vx-col lg:w-1/3 w-full mb-2"
                      style="padding: 0 5px"
                    >
                      <table>
                        <tr>
                          <td class="font-semibold">P.Value :</td>
                          <td>
                            {{ currentLrDetails.consignmentProductValue }}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
            <div class="vx-row" style="margin: 0px">
              <div class="vx-col lg:w-1/2 w-full" style="padding: 0 5px">
                <vx-card title="Consignor">
                  <table>
                    <tr>
                      <td class="font-semibold">Name :</td>
                      <td>
                        {{
                          currentLrDetails.consignor.consignmentConsignorName
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Mobile :</td>
                      <td>
                        {{
                          currentLrDetails.consignor
                            .consignmentConsignorMobileNo
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">GST No :</td>
                      <td>
                        {{
                          currentLrDetails.consignor.consignmentConsignorGstNo
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Address :</td>
                      <td>
                        {{
                          currentLrDetails.consignor.consignmentConsignorAddress
                        }}
                      </td>
                    </tr>
                  </table>
                </vx-card>
              </div>
              <div class="vx-col lg:w-1/2 w-full" style="padding: 0 5px">
                <vx-card title="Consignee">
                  <table>
                    <tr>
                      <td class="font-semibold">Name :</td>
                      <td>
                        {{
                          currentLrDetails.consignee.consignmentConsigneeName
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Mobile :</td>
                      <td>
                        {{
                          currentLrDetails.consignee
                            .consignmentConsigneeMobileNo
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">GST No:</td>
                      <td>
                        {{
                          currentLrDetails.consignee.consignmentConsigneeGstNo
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Address :</td>
                      <td>
                        {{
                          currentLrDetails.consignee.consignmentConsigneeAddress
                        }}
                      </td>
                    </tr>
                  </table>
                </vx-card>
              </div>
            </div>
            <vx-card class="mt-2" style="width: 98%; margin-left: 6px">
              <div class="vx-row" style="margin: 0px">
                <div class="vx-col w-full mb-2" style="padding: 0 5px">
                  <vs-table
                    max-items="3"
                    pagination
                    :data="currentLrDetails.packages"
                  >
                    <template slot="thead">
                      <vs-th>S No</vs-th>
                      <vs-th>Consignment Type</vs-th>
                      <vs-th>Quantity</vs-th>
                      <vs-th>Total Weight (Kgs)</vs-th>
                    </template>
                    <template slot-scope="{ data }">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>{{ indextr + 1 }}</vs-td>

                        <vs-td
                          :data="data[indextr].consignmentPackageTypeName"
                          >{{ data[indextr].consignmentPackageTypeName }}</vs-td
                        >
                        <vs-td
                          :data="data[indextr].consignmentPackageQuantity"
                          >{{ data[indextr].consignmentPackageQuantity }}</vs-td
                        >
                        <vs-td :data="data[indextr].consignmentPackageWeight">{{
                          data[indextr].consignmentPackageWeight
                        }}</vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </vx-card>
          </div>
        </VuePerfectScrollbar>
      </vx-card>
    </div>
    <div
      class="vx-col lg:w-2/5 w-full"
      style="padding-left: 5px"
      v-if="genrationFreight"
    >
      <div class="vx-row" style="margin: 0px">
        <div class="vx-col w-full" style="padding: 0 5px">
          <vx-card
            :title="'Freight Generated(' + successfullyUpdated.length + ')'"
          >
            <vs-table
              stripe
              pagination
              max-items="10"
              search
              :data="successfullyUpdated"
              v-if="successfullyUpdated.length > 0"
            >
              <template slot="thead">
                <vs-th sort-key="consignmentLrNo">LR.No</vs-th>
                <vs-th sort-key="consignmentFreightNo">Freight No</vs-th>
                <vs-th>Freight Charge</vs-th>
                <vs-th>Hamali Charge</vs-th>
                <vs-th>Stationary Charge</vs-th>
                <vs-th>Collection Charge</vs-th>
                <vs-th>DD Charge</vs-th>
                <vs-th>Other Charge</vs-th>
                <vs-th>LR Charge </vs-th>
                <vs-th>UnLoading Charge</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="tr.consignmentLrNo">{{
                    tr.consignmentLrNo
                  }}</vs-td>
                  <vs-td :data="tr.consignmentFreightNo">{{
                    tr.consignmentFreightNo
                  }}</vs-td>
                  <vs-td :data="tr.consignmentFreightCharge">
                    {{ tr.consignmentFreightCharge }}
                  </vs-td>
                  <vs-td :data="tr.consignmentHamaliCharge">
                    {{ tr.consignmentHamaliCharge }}
                  </vs-td>
                  <vs-td :data="tr.consignmentStationaryCharge">
                    {{ tr.consignmentStationaryCharge }}
                  </vs-td>
                  <vs-td :data="tr.consignmentCollectionCharges">
                    {{ tr.consignmentCollectionCharges }}
                  </vs-td>
                  <vs-td :data="tr.consignmentDoorDeliveryCharge">
                    {{ tr.consignmentDoorDeliveryCharge }}
                  </vs-td>
                  <vs-td :data="tr.consignmentOtherCharge">
                    {{ tr.consignmentOtherCharge }}
                  </vs-td>
                  <vs-td :data="tr.consignmentLrCopyCharge">
                    {{ tr.consignmentLrCopyCharge }}
                  </vs-td>
                  <vs-td :data="tr.consignmentUnloadingCharge">
                    {{ tr.consignmentUnloadingCharge }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
      <div class="vx-row" style="margin: 0px; margin-top: 10px">
        <div class="vx-col w-full" style="padding: 0 5px">
          <vx-card :title="'Failed Generating(' + failedUpdated.length + ')'">
            <vs-table
              stripe
              pagination
              max-items="10"
              search
              :data="failedUpdated"
              v-if="failedUpdated.length > 0"
            >
              <template slot="thead">
                <vs-th sort-key="consignmentLrNo">LR.No</vs-th>
                <vs-th>Freight Charge</vs-th>
                <vs-th>Hamali Charge</vs-th>
                <vs-th>Stationary Charge</vs-th>
                <vs-th>Collection Charge</vs-th>
                <vs-th>DD Charge</vs-th>
                <vs-th>Other Charge</vs-th>
                <vs-th>LR Charge </vs-th>
                <vs-th>UnLoading Charge</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="tr.consignmentLrNo">{{
                    tr.consignmentLrNo
                  }}</vs-td>

                  <vs-td :data="tr.consignmentFreightCharge">
                    {{ tr.consignmentFreightCharge }}
                  </vs-td>
                  <vs-td :data="tr.consignmentHamaliCharge">
                    {{ tr.consignmentHamaliCharge }}
                  </vs-td>
                  <vs-td :data="tr.consignmentStationaryCharge">
                    {{ tr.consignmentStationaryCharge }}
                  </vs-td>
                  <vs-td :data="tr.consignmentCollectionCharges">
                    {{ tr.consignmentCollectionCharges }}
                  </vs-td>
                  <vs-td :data="tr.consignmentDoorDeliveryCharge">
                    {{ tr.consignmentDoorDeliveryCharge }}
                  </vs-td>
                  <vs-td :data="tr.consignmentOtherCharge">
                    {{ tr.consignmentOtherCharge }}
                  </vs-td>
                  <vs-td :data="tr.consignmentLrCopyCharge">
                    {{ tr.consignmentLrCopyCharge }}
                  </vs-td>
                  <vs-td :data="tr.consignmentUnloadingCharge">
                    {{ tr.consignmentUnloadingCharge }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
    </div>
    <!-- <button type="button" @click="showPDF">showPDF</button> -->
    <!-- <div v-if="completedCollectionAgent" ref="testHtml"> -->
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import addEditCollectionAgent from "./../masters/collectionagent/add-edit-collectionagent.vue";

export default {
  data() {
    return {
      currentLrNo: null,
      lrDeatilsHeader: "LR Details",
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      formData: {
        collectionAgentName: null,
        collectionAgentId: 0,
        collectionAgentShortName: null,
        isActive: null,
      },
      freightUpdatingLrs: [],
      currentLrDetails: {},
      genrationFreight: false,
      successfullyUpdated: [],
      failedUpdated: [],
      loadingLrData: false,
      collectionAgents: [],
      collectionAgent: null,
      selectedCollectionAgent: null,
      completedCollectionAgent: false,
      showAddEditDialog: false,
      modalTitle: "Add Collection Agent",
      freightSessionId: null,

      // pdfUrl: "http://localhost:8081/transport-System/PDF/views/new/",
      pdfUrl: "https://newpdf.srisainadhtransport.in/2025/",
    };
  },
  methods: {
    agentSelected() {
      this.collectionAgent = this.selectedCollectionAgent.collectionAgentId;
    },
    reloadData(_event) {
      this.showAddEditDialog = false;
      this.$vs.notify({
        title: _event.data.message,
        color: "success",
        position: "top-right",
      });
      this.collectionAgents = _event.data.data;
    },
    showPDF(uniq) {
      const url =
        this.pdfUrl +
        "freightreceiptpdf.php?sessionId=" +
        uniq +
        "&token=" +
        localStorage.getItem("sessionToken");
      window.open(url, "_blank");
      return false;
    },
    getCollectionAgents() {
      this.$http.get("portage/collectionAgents").then((response) => {
        this.collectionAgents = response.data.data;
      });
    },
    getLrDetails(_e) {
      if (
        this.currentLrNo == 0 ||
        this.currentLrNo == "" ||
        this.currentLrNo == null
      ) {
        this.$vs.notify({
          title: `Please Enter LR NO`,
          color: "danger",
          position: "top-right",
        });
      } else {
        this.lrDetailsServiceRequest(this.currentLrNo);
      }
    },
    generateServiceCall() {
      this.$http
        .post(`portage/generateFreight`, { lrData: this.freightUpdatingLrs })
        .then((response) => {
          if (
            response.data.data.successLr.length ==
            this.freightUpdatingLrs.length
          ) {
            this.$vs.notify({
              title: `Total Lr's freight was generated ! Count ${response.data.data.successLr.length}`,
              color: "success",
              position: "top-right",
            });
            this.successfullyUpdated = response.data.data.successLr;
            this.genrationFreight = true;
          }
          if (response.data.data.failedLrs.length > 0) {
            const lrIds = response.data.data.failedLrs.map((d) => {
              return d.consignmentLrNo;
            });
            this.failedUpdated = response.data.data.failedLrs;
            this.genrationFreight = true;
            let copyString = `LR No:  ${lrIds.join(",")}`;
            console.log(copyString);
            copyString = copyString.toString();
            this.$copyText(copyString).then(function () {});
            this.$vs.notify({
              title: `Failed to Update ${response.data.data.failedLrs.length} Lr's.Please Send the Copied text to Admin !`,
              color: "danger",
              position: "top-right",
            });
          }

          console.log(response);
        })
        .catch((_error) => {
          // this.$vs.notify({
          //   title: error.response.data.message,
          //   color: "danger",
          //   position: "top-right",
          // });
        });
    },
    generateFreight() {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Genreate Freight Receipt?`,
        text: ``,
        acceptText: "Accept!",
        accept: this.generateServiceCall,
      });
      setTimeout(() => {
        if (document.getElementsByClassName("vs-dialog-text").length > 0) {
          document.getElementsByClassName(
            "vs-dialog-text"
          )[0].innerHTML = `Do you want to generate the Freight Receipt?<br/><blockquote>Total LR's: <b>${this.freightUpdatingLrs.length}</b></blockquote>`;
        }
      }, 0);
    },
    printFreight() {
      //Print Freight
      this.$vs.loading({
        container: "#printing_freight",
        scale: 0.6,
      });
      this.$http
        .post(`portage/printFreight`, {
          freighData: this.successfullyUpdated,
          collectionAgentId: this.collectionAgent,
        })
        .then((response) => {
          this.freightSessionId = response.data.data.uniqNum;
          this.$vs.loading.close("#printing_freight > .con-vs-loading");
          console.log(response);
          this.completedCollectionAgent = true;
          this.showPDF(response.data.data.uniqNum);
          if (response.data.data.failedFreight.length > 0) {
            console.log(response);
            const lrIds = response.data.data.failedFreight.map((d) => {
              return d.consignmentLrNo;
            });
            this.failedUpdated = response.data.data.failedLrs;
            let copyString = `LR No:  ${lrIds.join(",")}`;
            copyString = copyString.toString();
            this.$copyText(copyString).then(function () {});
            this.$vs.notify({
              title: `Failed to Add Collection Agent ${response.data.data.failedFreight.length}.Please Paste the copied Lrs`,
              color: "danger",
              position: "top-right",
            });
          } else {
            console.log(response);
            this.$router.push("/");
            // window.location.reload();
            // alert(response.data.data.uniqNum);
          }
          // window.reload();
        })
        .catch((_error) => {
          // this.$vs.notify({
          //   title: error.response.data.message,
          //   color: "danger",
          //   position: "top-right",
          // });
        });
    },
    removeConsignment(_row, _index) {
      this.freightUpdatingLrs.splice(_index, 1);
    },
    currentFreight(_row, _index) {
      this.lrDeatilsHeader =
        "LR Details : " +
        _row.consignmentLrNo +
        " (Booking Type : " +
        _row.consignmentBookingPaymentTypeName +
        " )";
      this.currentLrDetails = _row;
    },
    showLrDetails() {
      //code here
      this.currentLrNo = "";
      console.log(this.$refs);
      this.$nextTick(() => {
        this.loadingLrData = false;
        setTimeout(() => {
          this.$refs.lrgenerateText.$el.children[0].children[0].focus();
        }, 10);
      });
      // lrgenerateText
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },
    lrDetailsServiceRequest(lrNo) {
      this.loadingLrData = true;
      this.currentLrDetails = {};
      if (this.freightUpdatingLrs.length > 0) {
        const lrIndex = this.freightUpdatingLrs.findIndex(
          (lr) => lr.consignmentLrNo == this.currentLrNo
        );
        if (lrIndex >= 0) {
          this.currentLrDetails = this.freightUpdatingLrs[lrIndex];
          this.showLrDetails();
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");

          this.$vs.notify({
            title: `LR Was already Added for Freight Generation.LR No ${this.freightUpdatingLrs[lrIndex].consignmentLrNo}`,
            color: "danger",
            position: "top-right",
          });
        } else {
          this.$vs.loading({
            container: "#div-with-loading",
            scale: 0.6,
          });
          this.$http
            .get(`portage/getLrDetails/${lrNo}`)
            .then((response) => {
              console.log(response);
              if (response) {
                console.log(response);
                this.freightUpdatingLrs.push(response.data.data);
                this.currentLrDetails = response.data.data;
                this.showLrDetails();
                this.lrDeatilsHeader =
                  "LR Details : " +
                  response.data.data.consignmentLrNo +
                  " (Booking Type : " +
                  response.data.data.consignmentBookingPaymentTypeName +
                  " )";
              } else {
                this.showLrDetails();
                this.$vs.notify({
                  title: "Please Check LR No",
                  color: "danger",
                  position: "top-right",
                });
              }
            })
            .catch((error) => {
              this.$vs.notify({
                title: error.response.data.message,
                color: "danger",
                position: "top-right",
              });
              this.showLrDetails();
              // console.log();
            });
        }
      } else {
        this.$vs.loading({
          container: "#div-with-loading",
          scale: 0.6,
        });
        this.$http
          .get(`portage/getLrDetails/${lrNo}`)
          .then((response) => {
            console.log(response);
            if (response) {
              console.log(response);
              this.freightUpdatingLrs.push(response.data.data);
              this.currentLrDetails = response.data.data;
              this.showLrDetails();
              this.lrDeatilsHeader =
                "LR Details : " +
                response.data.data.consignmentLrNo +
                " (Booking Type : " +
                response.data.data.consignmentBookingPaymentTypeName +
                " )";
            } else {
              this.showLrDetails();
              this.$vs.notify({
                title: "Please Check LR No",
                color: "danger",
                position: "top-right",
              });
            }
          })
          .catch((error) => {
            this.showLrDetails();
            this.$vs.notify({
              title: error.response.data.message,
              color: "danger",
              position: "top-right",
            });
            // console.log();
          });
      }
    },
  },
  computed: {},
  components: {
    VuePerfectScrollbar: VuePerfectScrollbar,
    "v-select": vSelect,
    addEditCollectionAgent: addEditCollectionAgent,
  },
  mounted() {
    this.freightUpdatingLrs = [];
    this.getCollectionAgents();
  },
};
</script>

<style>
.scroll-area--customizer {
  height: calc(100% - 5rem);
}
.freightlrDetails .vx-card__body {
  padding: 2px !important;
}
.freightlrList .vx-card__body {
  padding: 2px !important;
}
</style>